import { useState, useCallback } from 'react';
import { reelService } from 'api/services/ReelService';

export interface UseDeleteReelResult {
  deleteReel: (id: string) => Promise<{ ok: boolean; message: string }>;
  loading: boolean;
  error: string | null;
  resetError: () => void;
}

/**
 * Delete a reel via DELETE /api/reels/{id}.
 */
export function useDeleteReel(): UseDeleteReelResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteReel = useCallback(
    async (id: string): Promise<{ ok: boolean; message: string }> => {
      setLoading(true);
      setError(null);
      try {
        const result = await reelService.delete(id);
        if (result.isSuccess) {
          return { ok: true, message: result.message ?? 'Reel başarıyla silindi.' };
        }
        const message = result.message ?? 'Silme başarısız.';
        setError(message);
        return { ok: false, message };
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Bir hata oluştu.';
        setError(msg);
        return { ok: false, message: msg };
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const resetError = useCallback(() => setError(null), []);

  return { deleteReel, loading, error, resetError };
}
